module.exports = __webpack_public_path__ + "static/media/secondFloorSide.75eebfee.png";